import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import { useEffect } from 'react';
import '../useEventCallback/f88967e05c363a5188b325fb4d627649a074011bce9e7eb26a8a7978a87e100f.cfe-internal.js';
import useEventCallback from '../useEventCallback/0ebce52fac2aa94b4cad29a85740b8586bddbccb9acd7c8786ebbfef7b665ae0.cfe-internal.js';

function isEventTarget(target) {
  return !!target.addEventListener;
}
/**
 * Adds and cleans up event listener from the specified target
 * @param targetOrRef - An event target or ref pointing to one.
 * @param event - Event to listen for.
 * @param handler - Handler to call when event is fired.
 * @param options.isCaptureEvent - Whether to run the event in the capture phase,
 * defaults to false (i.e. run in bubbling phase)
 * @param options.enabled - Whether event is enabled, defaults to true
 * @param options.additionalDependencies - additional dependencies to add to the use effect
 * should be a static list of values, defaults to []
 */
function useEventListener(targetOrRef, event, handler) {
  var _context;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var listener = useEventCallback(handler);
  var _options$isCaptureEve = options.isCaptureEvent,
    isCaptureEvent = _options$isCaptureEve === void 0 ? false : _options$isCaptureEve,
    _options$isDisabled = options.isDisabled,
    isDisabled = _options$isDisabled === void 0 ? false : _options$isDisabled,
    _options$additionalDe = options.additionalDependencies,
    additionalDependencies = _options$additionalDe === void 0 ? [] : _options$additionalDe;
  useEffect(function () {
    var target = isEventTarget(targetOrRef) ? targetOrRef : targetOrRef.current;
    if (target !== null && target !== void 0 && target.addEventListener && !isDisabled) {
      target.addEventListener(event, listener, isCaptureEvent);
      return function () {
        return target.removeEventListener(event, listener, isCaptureEvent);
      };
    }
    return undefined;
  }, _concatInstanceProperty(_context = [targetOrRef, event, listener, isCaptureEvent, isDisabled]).call(_context, _toConsumableArray(additionalDependencies)));
}

export { useEventListener as default };
